import {
  useAdvancedBounceRateFilter,
  useAverageVisitDurationFilter,
  useBounceRateFilter,
  useConversionEventCountFilter,
  usePageCountFilter,
  useVisitCountFilter,
} from './pre-defined';
import { useSessionMetricsFilters } from './useSessionMetricsFilters';

export const useMetadataAnalyticsFilters = () => {
  const { allFilters } = useSessionMetricsFilters();

  const visitCountFilter = useVisitCountFilter();
  const pageCountFilter = usePageCountFilter();
  const averageVisitDurationFilter = useAverageVisitDurationFilter();
  const bounceRateFilter = useBounceRateFilter();
  const advancedBounceRateFilter = useAdvancedBounceRateFilter();
  const conversionEventCountFilter = useConversionEventCountFilter();

  return [
    ...allFilters,
    visitCountFilter,
    pageCountFilter,
    averageVisitDurationFilter,
    bounceRateFilter,
    advancedBounceRateFilter,
    conversionEventCountFilter,
  ];
};
